// Bridge between the upload service layer and the <PdfPasswordPrompt /> modal
// mounted in App. The modal registers a handler; services call
// promptPdfPassword() and get a Promise resolving to the password, or null if
// the user cancelled.

let handler = null;

export const setPdfPasswordPromptHandler = (fn) => {
  handler = fn;
  return () => {
    if (handler === fn) handler = null;
  };
};

export const promptPdfPassword = (code, fileName) => {
  if (handler) return handler({ code, fileName });

  // Fallback when the modal isn't mounted (shouldn't happen inside the app).
  const name = fileName || "this PDF";
  const message =
    code === "password_invalid"
      ? `Incorrect password for "${name}". Please re-enter the PDF password:`
      : `"${name}" is password protected. Please enter the PDF password to upload it:`;
  return Promise.resolve(window.prompt(message));
};
